module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_7"
    }
  }, [_c('span', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Tuesday, September 25, 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("BARRY DAVIS")]), _vm._v(" didn’t work out of an office. It was more a closet crammed with tech, located on the third floor. A sign on the door asked visitors to knock before entering, and another warned of imminent death if anything was removed without his permission.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary stood in the open doorway, watching as Barry skimmed the list.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He gave a low whistle. “I had no idea.” Barry lowered his gaze to the stapled document in his hand. “You think you know all about someone, and then….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It isn’t something I talk about,” Gary admitted. As far as he knew, the number of people in the know about his brother’s murder could be counted on one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So in other words, I don’t talk about it either.” Barry nodded. “Gotcha. And you’ve okayed this with Travers?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup. I’ve emailed you the list as well. But the first thing you need to do is—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Find the look-alike cases,” Barry interjected. “I’ll use 1995 as my starting point. Want me to look outside of the state too? Or will that depend on what I find here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll leave that up to you. And Barry?” When Barry looked him in the eye, Gary forced a smile. “No rush, okay? You work on this whenever you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Barry’s brown eyes were warm. “You’ve waited this long, I’m not gonna keep you hanging on for answers.” Then he grinned. “The wife wants me to repaint the house.” He waved the sheets. “What a pity I’m gonna be busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Now wait a sec. I don’t want to be named in your divorce proceedings,” Gary joked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Barry laughed, but then the light died in his face. “I’m sorry, Gary. No one should have to live through this. I’m gonna do everything I can to help you find this bastard.” Just then Dan appeared next to Gary, carrying a plain brown bag from which came an enticing smell that tickled Gary’s nostrils. Barry inclined his head toward Dan. “I dare say he’s gonna lend a hand too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dan is the reason you’re holding that list.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then I’m glad he’s got your back.” Barry cast a hopeful glance at the bag, but when nothing was forthcoming, he huffed. “I can be bribed to work faster, you know. Especially if paid in coffee and pastries.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan gaped at him. “How’d you know I’ve got pastries in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Barry tapped his nose. “There’s no fooling this.” He waved the sheets once more. “I’ll let you know if I come up with something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary extended a hand and they shook. “Thanks, Barry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, I’ve got a reputation to live up to, haven’t I?” He grinned. “The department’s tech whiz kid.” Then he returned his attention to his monitor.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Apparently they were done.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary glanced at Dan’s bag as they headed downstairs to the second floor where their office was located. He sniffed the air. “Now I know why you disappeared right after we arrived this morning.” The delicious aroma of freshly brewed coffee and cinnamon rolls called to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Riley was going to Phil’s Place, and I thought we needed a little sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If I keep eating Phil’s cinnamon rolls, you’ll have a fat man on your hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s eyes sparkled. “More of you? Won’t catch me complaining about that.” He chuckled. “Don’t worry. It’s not about to become an everyday occurrence.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They reached the office, and as soon as the door closed, Dan put the bag down and walked over to him. “Are you okay? That had to be rough.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary performed a quick mental assessment, and his conclusion came as a shock. “You know what? I’m fine. A short time ago, I’d have been a real mess just saying Brad’s name, so I’d say this is an improvement.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A welcome improvement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan glanced at the pile of folders. “I swear there are more of them than there were before I went for coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary dipped his chin to his chest, his face growing warm. “Yeah, about that… I might have added a few.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan reached into the bag and removed the coffee cups, handing one to him. “So… did any cases stand out? Really interesting ones?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s what you’re going to tell me.” Gary indicated the folders. “I’m going to follow your lead on this one. You get to choose. Let your instincts guide you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They hadn’t steered them wrong yet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s forehead wrinkled, and Gary peered at him. “You okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s what you said about my instincts.” Dan met his gaze. “You "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("know")]), _vm._v(" I’m not the all-knowing psychic the media makes me out to be, right? I mean, I haven’t ever simply looked at the evidence and solved the case, just like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s not how I see your role at all,” Gary assured him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan tilted his head. “Then how "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("do")]), _vm._v(" you see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary tried to frame his thoughts. “Your gift isn’t infallible. It’s not always reliable, but―”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, I’d be the first to admit that’s the truth,” Dan remonstrated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary held up a hand. “Let me finish, please?” He lowered it, then took Dan’s hands in his. “More than anything, you help point us in the right direction. You add strength to our procedures. Hopefully I’m teaching you some of the things I’ve learned over the years. Because I don’t see my role in this department as the guy who flashes his badge to get you into a place so you can touch stuff to solve the crime, okay? I see us as equal partners.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s face glowed. “The Dynamic Duo, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You provide intellectual insights that are as useful as your psychic ones—sometimes more useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, if we’re dishing out compliments”—Dan smiled—“you’re a damn good detective with solid investigative skills, but don’t dismiss the importance of your intuition. That’s just as useful.” Dan moved closer, and Gary was thankful for the closed door. “But when you take into consideration what we share "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("outside")]), _vm._v(" of work?” He cupped Gary’s cheek. “I think that makes our working relationship all the stronger.” Dan leaned in, wrapped his arms around him, and kissed him on the lips, a lingering embrace that obliterated all traces of the discomfort Gary had felt when he’d talked with Barry.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Someone could walk in at any minute,” Gary murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Let them. All they’d see are two guys sharing a moment.” Dan shifted his gaze lower. “Oh. Yeah. They might see that too.” He grinned, released Gary, and took a step back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I blame you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan widened his eyes. “I take no responsibility for your body’s reactions.” He sighed. “I didn’t mean that, by the way.” Gary gave him a puzzled glance. “That bit about letting people see us indulging in a PDA. I wouldn’t put you in that position.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So it’s okay if I stay in the closet a little longer?” Gary wasn’t ready to let everyone know their business.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That earned him a light kiss on the tip of his nose. “Perfectly okay.” Dan took a step back and inclined his head toward the desk where the folders sat in neat piles. “Let’s get to work before Travers walks in and suggests "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("another")]), _vm._v(" case that looks innocent enough but ends up being bigger than either of us anticipated.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think I’m going to need that sugar,” Gary muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("DAN CLOSED")]), _vm._v(" the folder with a sigh. Despite voicing a desire for a simpler case, he had to admit nothing in the folders he’d read so far piqued his curiosity or awoke his senses.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Not one of them calls out to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Maybe he was expecting too much of his gift.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Maybe he should spread the folders out, close his eyes, and stick a pin in one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was conscious of letting Gary down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan glanced across the room to where Gary was reading. “I know what you said before, but I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("also")]), _vm._v(" have this feeling you’re waiting for me to announce dramatically that I’ve found something interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary looked up, his eyebrows arched. “I’m doing no such thing. In fact, I’m reading a very interesting case.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His pulse quickened. “Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary snorted. “I’m lying. It’s dull as ditch water, not that it matters. It’s still a case to be solved, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It seemed neither of them had been bitten yet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan reached for another folder, labeled LEO DEAKINS, 2015. He opened it and scanned the top sheet before leafing through the rest of the documents. He stopped when one part of the report caught his eyes. “Wait a minute….” The base of his neck tingled, and his pulse raced again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What have you found?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan grinned. “Something interesting.” He gestured to Gary’s computer. “Pull up the case of Leo Deakins, from 2015.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary tapped on the keyboard. “Why did this one speak to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan read from the sheet. “Leo Deakins, aged twenty. Student at Boston University. Found dead in Jamaica Plain, May 21, 2015. Shot in the back of the head. It looks as though he was buying drugs.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Quite possibly. There are parts of Jamaica Plain where that happens a lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Police also found a substantial amount of drugs on him,” Dan continued. “No money, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary frowned. “So why the interest? Something went wrong with the deal, and the pushers shot him. End of story.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan blinked. “So he paid for his drugs, they shot him in the back of the head, then left the drugs on him?” He stared at Gary. “Doesn’t that strike you as odd?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Now you mention it….” Gary tapped some more. “Okay, now that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("is")]), _vm._v(" interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s arms erupted into goose bumps. He recognized the undercurrent of some strong emotion in Gary’s voice. “What have you seen?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The ballistics report. He was shot with a frangible bullet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan was none the wiser. “And?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Gary leaned back. “Well, it’s the kind of bullet you tend to see when law enforcement is involved.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It took a moment for his words to register. “So you’re saying he was shot by a cop?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m not saying anything, but it "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("is")]), _vm._v(" interesting, don’t you think?” Gary peered at the monitor again. “And the plot thickens.” He glanced at Dan. “Have you got the page with statements from informants?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait, let me find it.” Dan rifled through the sheaf of papers. “So the police really do use informants?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. Sometimes they give us a tip-off that something’s going down, or even a heads-up that something is about to happen. We have a few informants who keep us in the loop with regards to the drug scene in Boston. But in Deakins’s case—” Gary looked at the monitor. “—not one of them was able to recall ever having seen him in such a deal. In fact, they’d never seen him before.” Gary leaned back. “Maybe it was his first drug deal, he didn’t know the ropes, and it went badly.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan’s goose bumps would "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not")]), _vm._v(" quit. “Then we go with this one. Call it a hunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m starting to trust your hunches.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dan lowered the folder. “Remember what Travers said when he told the department about what we’d be doing. He said to imagine if someone we loved had died in unexplained circumstances. Well, the circumstances look obvious in this case, but somewhere out there is Deakins’s family, and they need closure. They need to know the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What exactly are you hoping to find?” Gary asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know,” Dan replied honestly. “All I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("do")]), _vm._v(" know is there’s something about this case that… pulls me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had to find Leo Deakins’s truth.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79399106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 75
// module chunks = 0